import type { z } from "zod";

import type { OrganisationId, WorkflowVersion } from "@thalamos/vision-common";
import { createInitialValues, tk, workflows } from "@thalamos/vision-common";

import { MultiPageForm } from "../../components/FormBuilder/MultiPageForm/MultiPageForm.js";
import { Error } from "../../pages/Error/Error.js";

type WorkflowSchema<T extends WorkflowVersion> = z.infer<
  ReturnType<
    (typeof workflows)[T]["createIncident"]["formDefinition"]["sections"][0]["buildFormSpecification"]
  >["formSchema"]
>;

export type CreateIncidentWorkItemFormProps<T extends WorkflowVersion> = {
  onSubmit: (value: WorkflowSchema<T>) => Promise<void>;
  onCancel: () => void;
  defaultCommandUnitOrganisationId: OrganisationId;
  workflowVersion: T;
};

export function CreateIncidentWorkItemForm<T extends WorkflowVersion>({
  onSubmit,
  onCancel,
  // TODO: Do we need this?
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  defaultCommandUnitOrganisationId,
  workflowVersion,
}: CreateIncidentWorkItemFormProps<T>) {
  const workflow = workflows[workflowVersion];
  const formSpecification =
    workflow?.createIncident.formDefinition.sections[0]?.buildFormSpecification(
      {},
    );

  if (formSpecification === undefined) {
    return <Error />;
  }

  const schema = formSpecification.formSchema;
  const strictFieldSchemas = formSpecification.strictFieldSchemas;

  return (
    <MultiPageForm<typeof schema>
      headerText={tk("createIncident.newIncidentForm")}
      schema={schema}
      strictFieldSchemas={strictFieldSchemas}
      initialValues={createInitialValues(strictFieldSchemas)}
      pages={formSpecification.pages}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  );
}
